export default __webpack_public_path__ + "static/media/egypt.4eb5a29e.svg";